/** Build hierarchical tree for on-site sunburst: dept → team → people count. */

export function buildOnSiteSunburstTree(rows) {
  const deptMap = new Map();

  rows.forEach((row) => {
    const dept = row.department?.trim() || 'Unassigned';
    const team = row.team?.trim() || 'No team';
    if (!deptMap.has(dept)) deptMap.set(dept, new Map());
    const teamMap = deptMap.get(dept);
    if (!teamMap.has(team)) teamMap.set(team, []);
    teamMap.get(team).push(row);
  });

  const children = [...deptMap.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([department, teamMap]) => {
      const teamChildren = [...teamMap.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([team, people]) => ({
          name: team,
          value: people.length,
          category: 'team',
          department,
          people: people.map((p) => p.name).sort(),
        }));

      const deptCount = teamChildren.reduce((s, t) => s + t.value, 0);
      return {
        name: department,
        value: deptCount,
        category: 'department',
        children: teamChildren,
      };
    });

  const total = children.reduce((s, c) => s + c.value, 0);

  return {
    name: 'On site',
    value: total,
    category: 'root',
    children,
  };
}
